module.exports = __webpack_public_path__ + "static/media/avatar.02407ba7.jpg";